import shenqing from "@/components/diaodu/shenqing"
import feiyong from "@/components/diaodu/feiyong";
import diaodudan from "@/components/diaodu/diaodudan";

import daibanchuli from "@/components/diaodu/daibanchuli"
import yibanchuli from "@/components/diaodu/yibanchuli";
import liucheng from "@/components/diaodu/liucheng";
import form from "@/components/diaodu/form";
var data = [
  {
    path: "/shenqing",
    component: shenqing
  },
  {
    path: "/daibanchuli",
    component: daibanchuli
  },
  {
    path: "/yibanchuli",
    component: yibanchuli
  },
  {
    path: "/liucheng",
    component: liucheng
  },
  {
    path: "/form",
    component: form
  },
  {
    path: "/feiyong",
    component: feiyong
  },
  {
    path: "/diaodudan",
    component: diaodudan
  },
  {
    path: "/paichefeiyong",
    component: () => import("@/components/diaodu/caiwu/paichefeiyong")
  },
  {
    path: "/ddcc",
    component: () => import("@/components/diaodu/diaoduChuche")
  },
  {
    path: "/paiCheZhuangTai",
    component: () => import("@/components/diaodu/paiCheZhuangTai")
  }
];
export default data;



// WEBPACK FOOTER //
// ./src/router/diaodu.js